module.exports = __webpack_public_path__ + "media/photo/Component 68 – 1-8849d8dc.png";